export interface ReportQA {
  question: string;
  answer: string;
  scene: string;
  time: string;
}

export interface ReportFaceSwap {
  templateName: string;
  templateCategory: string;
  resultImage: string;
  time: string;
}

export interface ReportSceneVisit {
  name: string;
  time: string;
  duration: number;
  icon: string;
  color: string;
}

export interface ReportSample {
  id: string;
  visitorName: string;
  age: number;
  hometown: string;
  ship: string;
  tripDate: string;
  tripBatch: string;
  deviceNo: string;
  qrCode: string;
  template: string;
  avatar: string;
  tripPhoto: string;
  totalTime: number;
  questionCount: number;
  faceswapCount: number;
  scenesVisited: number;
  satisfactionScore: number;
  qaList: ReportQA[];
  faceSwaps: ReportFaceSwap[];
  sceneVisits: ReportSceneVisit[];
  tripHighlight: string;
}

export const reportSamples: ReportSample[] = [
  {
    id: "sample-1",
    visitorName: "陈明远",
    age: 38,
    hometown: "北京",
    ship: "长江壹号",
    tripDate: "2026-06-01",
    tripBatch: "上午批次 08:00-16:00",
    deviceNo: "A001",
    qrCode: "RPT-20260601-001",
    template: "经典版报告",
    avatar: "/assets/img/992cf40a3febb85d.jpg",
    tripPhoto: "/assets/img/b85ce692651c34d0.jpg",
    totalTime: 480,
    questionCount: 12,
    faceswapCount: 2,
    scenesVisited: 6,
    satisfactionScore: 98,
    tripHighlight: "在葛洲坝观景台听到那一段历史讲解的时候，我才真正理解了为什么说三峡是中国人的精神图腾。那一刻真的很震撼。",
    qaList: [
      { question: "三峡大坝蓄水位是多少米？", answer: "三峡大坝正常蓄水位为175米，坝顶高程185米，总库容393亿立方米，是目前世界上已建成的最大水利枢纽工程之一。", scene: "三峡大坝", time: "09:23" },
      { question: "葛洲坝什么时候建成投入使用的？", answer: "葛洲坝水利枢纽于1971年开工建设，1981年大江截流，1988年全面建成投入运营，是三峡工程的重要组成部分和三峡大坝的'姐妹坝'。", scene: "葛洲坝", time: "10:45" },
      { question: "西陵峡的长度和特点是什么？", answer: "西陵峡全长66公里，是三峡中最长的峡谷，以滩多水急、礁石林立著称。历史上这里曾是航行的天险，如今经过整治已成为安全的黄金水道。", scene: "西陵峡", time: "11:30" },
      { question: "屈原出生在哪里？他为什么投江？", answer: "屈原出生于归州（今湖北秭归县），是战国时期楚国的著名诗人和政治家。公元前278年，秦军攻破楚国首都，屈原在绝望中于农历五月初五投汨罗江而亡，后人为纪念他演变出端午节。", scene: "屈原故里", time: "13:12" },
      { question: "神女峰的传说是怎么来的？", answer: "神女峰位于巫山县，传说是天上瑶姬仙女因留恋三峡美景而化为石峰。明代大旅行家徐霞客曾记载'峰与云平，望之如亿万玉女列队而立'。古往今来无数文人墨客在此留下诗篇。", scene: "巫山神女峰", time: "14:20" },
      { question: "三峡工程发电量有多大？", answer: "三峡水电站总装机容量2250万千瓦，年均发电量约1000亿千瓦时，相当于每年节约原煤5000万吨，是全球最大的水力发电站，为华中、华东及广东等地区提供清洁电力。", scene: "三峡大坝", time: "15:08" },
    ],
    faceSwaps: [
      {
        templateName: "鲟侠船长造型",
        templateCategory: "IP形象",
        resultImage: "/assets/img/7bef19013151857c.jpg",
        time: "10:18",
      },
      {
        templateName: "三峡日出",
        templateCategory: "景点合影",
        resultImage: "/assets/img/d4b93c6d3557c63a.jpg",
        time: "14:55",
      },
    ],
    sceneVisits: [
      { name: "三峡大坝", time: "09:10", duration: 85, icon: "ri-building-2-line", color: "text-teal-600" },
      { name: "葛洲坝", time: "10:40", duration: 60, icon: "ri-water-flash-line", color: "text-blue-600" },
      { name: "西陵峡", time: "11:25", duration: 45, icon: "ri-landscape-line", color: "text-emerald-600" },
      { name: "屈原故里", time: "13:05", duration: 55, icon: "ri-ancient-pavilion-line", color: "text-amber-600" },
      { name: "巫山神女峰", time: "14:10", duration: 50, icon: "ri-landscape-line", color: "text-rose-500" },
      { name: "白帝城", time: "15:20", duration: 40, icon: "ri-building-line", color: "text-purple-600" },
    ],
  },
  {
    id: "sample-2",
    visitorName: "李婷",
    age: 29,
    hometown: "上海",
    ship: "长江壹号",
    tripDate: "2026-06-01",
    tripBatch: "上午批次 08:00-16:00",
    deviceNo: "A003",
    qrCode: "RPT-20260601-003",
    template: "亲子版报告",
    avatar: "/assets/img/c961e14c3f78b653.jpg",
    tripPhoto: "/assets/img/bb50a6add24041e1.jpg",
    totalTime: 480,
    questionCount: 15,
    faceswapCount: 3,
    scenesVisited: 5,
    satisfactionScore: 100,
    tripHighlight: "神女峰的云雾真的太美了，站在那里感觉像在云端。用AR眼镜听到神女的传说讲解时，整个人都起鸡皮疙瘩，非常奇妙的体验！",
    qaList: [
      { question: "巫山小三峡在哪里？", answer: "巫山小三峡位于重庆市巫山县，是大宁河下游三段峡谷（龙门峡、巴雾峡、滴翠峡）的总称，全长约60公里，以奇峰、幽谷、碧水、怪石、野趣著称，是国家5A级景区。", scene: "巫山", time: "09:45" },
      { question: "三峡的人文历史从什么时候开始的？", answer: "三峡地区人类活动历史超过200万年，大溪文化遗址证明新石器时代已有先民在此定居。这里是巴楚文化的发祥地，历史上著名的刘备托孤、李白夜发白帝城、屈原流放等都与三峡密切相关。", scene: "白帝城", time: "10:30" },
      { question: "长江豚类为什么濒临灭绝？", answer: "长江豚类（包括白鳍豚和江豚）濒危的主要原因包括：人类活动干扰、航运污染、渔业捕捞误伤、栖息地破坏等。2006年白鳍豚已被宣告功能性灭绝，长江江豚目前仅约1000头，已列为国家一级保护动物。", scene: "长江豚保护区", time: "11:50" },
      { question: "神女峰是天然形成还是人工雕凿的？", answer: "神女峰完全是天然形成的，是喀斯特地貌长期受地质构造运动和流水侵蚀的结果。巫山一带地壳抬升，岩层受差异侵蚀形成这根独特的孤峰，高约80米。其形态酷似端庄女子，故名神女峰。", scene: "巫山神女峰", time: "14:35" },
      { question: "三峡移民是什么情况？", answer: "三峡工程建设共移民约130万人，是世界上规模最大的水库移民工程。1993年至2010年间，重庆、湖北两省市20个县市区的移民被安置在全国21个省市，国家投入移民经费超过700亿元。", scene: "三峡移民纪念馆", time: "15:20" },
    ],
    faceSwaps: [
      {
        templateName: "神女峰传说",
        templateCategory: "景点合影",
        resultImage: "/assets/img/6af7c6c664cde490.jpg",
        time: "14:50",
      },
      {
        templateName: "古风游船",
        templateCategory: "古风系列",
        resultImage: "/assets/img/29a36977c09f7f2e.jpg",
        time: "11:20",
      },
      {
        templateName: "江豚守护者",
        templateCategory: "IP形象",
        resultImage: "/assets/img/b162e46427503d75.jpg",
        time: "12:05",
      },
    ],
    sceneVisits: [
      { name: "巫山神女峰", time: "09:30", duration: 70, icon: "ri-landscape-line", color: "text-rose-500" },
      { name: "小三峡", time: "11:00", duration: 90, icon: "ri-water-flash-line", color: "text-blue-600" },
      { name: "长江豚保护区", time: "12:30", duration: 40, icon: "ri-heart-3-line", color: "text-teal-600" },
      { name: "白帝城", time: "13:20", duration: 65, icon: "ri-building-line", color: "text-amber-600" },
      { name: "三峡移民纪念馆", time: "15:05", duration: 55, icon: "ri-ancient-gate-line", color: "text-purple-600" },
    ],
  },
  {
    id: "sample-3",
    visitorName: "张家豪",
    age: 52,
    hometown: "成都",
    ship: "三峡盛世",
    tripDate: "2026-06-01",
    tripBatch: "下午批次 13:00-20:00",
    deviceNo: "B007",
    qrCode: "RPT-20260601-014",
    template: "经典版报告",
    avatar: "/assets/img/16ab48ccf02abc14.jpg",
    tripPhoto: "/assets/img/39fc1c453c088451.jpg",
    totalTime: 420,
    questionCount: 18,
    faceswapCount: 1,
    scenesVisited: 5,
    satisfactionScore: 96,
    tripHighlight: "在屈原故里，当AR眼镜播放那段《离骚》的时候，配合着橘园里的橘花香气，我忍不住眼眶湿润了。这种沉浸式体验是以前任何旅游方式都无法比拟的。",
    qaList: [
      { question: "屈原的离骚主要写了什么内容？", answer: "《离骚》是屈原最重要的作品，长达373句、2490字，是中国文学史上第一部长篇政治抒情诗。全诗以诗人自叙身世为主线，通过诉说政治抱负的失意、对楚国命运的忧虑以及对理想的追求，表达了强烈的爱国情怀和高洁的人格追求。", scene: "屈原故里", time: "13:40" },
      { question: "秭归的橘文化从哪里来？", answer: "秭归是中国著名的脐橙之乡，种橘历史超过2500年。屈原的《橘颂》是中国文学史上第一首以植物为主题的咏物诗，以橘树喻人的高洁品格。如今秭归脐橙年产量超过60万吨，是当地支柱产业。", scene: "屈原故里", time: "14:15" },
      { question: "三峡工程对生态环境的影响如何？", answer: "三峡工程对生态的影响是双面的：正面影响包括减少洞庭湖等地区洪涝灾害、提供清洁能源；负面影响包括阻断鱼类洄游通道、库区泥沙淤积、部分物种栖息地丧失等。目前国家已开展长江十年禁渔和多项生态修复工程。", scene: "三峡大坝", time: "15:30" },
      { question: "李白在三峡留下了哪些诗篇？", answer: "李白与三峡渊源极深，留下了大量名篇。最著名的是《早发白帝城》：'朝辞白帝彩云间，千里江陵一日还。两岸猿声啼不住，轻舟已过万重山。'此外还有《峨眉山月歌》《望天门山》等，从不同角度描绘了三峡的壮美。", scene: "白帝城", time: "16:50" },
      { question: "三峡库区的历史文物是怎么保护的？", answer: "三峡工程建设前，国家组织了规模空前的文物抢救行动，历时近20年，共发掘文物古迹1200余处，出土文物100余万件。部分无法迁移的地面文物采用原地保护或抬高复建，张飞庙等重要建筑整体迁建到新址。", scene: "三峡移民纪念馆", time: "17:35" },
    ],
    faceSwaps: [
      {
        templateName: "屈原赋诗",
        templateCategory: "古风系列",
        resultImage: "/assets/img/eb4cb95363684e5f.jpg",
        time: "14:40",
      },
    ],
    sceneVisits: [
      { name: "屈原故里", time: "13:20", duration: 90, icon: "ri-ancient-pavilion-line", color: "text-amber-600" },
      { name: "张飞庙", time: "15:00", duration: 50, icon: "ri-building-4-line", color: "text-red-500" },
      { name: "三峡大坝", time: "16:10", duration: 60, icon: "ri-building-2-line", color: "text-teal-600" },
      { name: "白帝城", time: "17:20", duration: 55, icon: "ri-building-line", color: "text-purple-600" },
      { name: "三峡移民纪念馆", time: "18:25", duration: 45, icon: "ri-ancient-gate-line", color: "text-blue-600" },
    ],
  },
];